<template>
    <loading v-if="loading"></loading>
    <div class="follow" v-else>
        <div class="follow-box">
            <div class="follow-left" style="overflow:auto">
                <div class="follow-left-title">我的关注（{{myFollow.length}}）</div>
                <div class="follow-left-content list infinite-list-wrapper" v-infinite-scroll="load2" infinite-scroll-disabled="disabled2" v-if="myFollow.length>0">
                    <div class="follow-left-content-box" v-for="(item,index) in myFollow" :key="index">
                        <div class="follow-left-content-box-left" @click="goUserDetails(item.be_user.id)">
                            <img :src="item.be_user.avatar" alt="">
                            <div class="follow-left-content-box-left-msg">
                                <div>{{item.be_user.nickname}}</div>
                                <div>ID：{{item.be_user.id}}</div>
                            </div>
                        </div>
                        <div class="follow-left-content-box-right" @click.stop="canelFollow(item.be_user.id)">取消关注</div>
                    </div>
                </div>
                <div class="follow-left-noContent" v-if="noData2">暂无数据</div>
                <p class="p" v-if="workLoading2">加载中...</p>
                <p class="p" v-if="noMore2 && myFollow.length>0 && !workLoading2">没有更多了~</p>
            </div>
        </div>
        <div class="follow-box">
            <div class="follow-left" style="overflow:auto">
                <div class="follow-left-title">关注我的（{{followMy.length}}）</div>
                <div class="follow-left-content list infinite-list-wrapper" v-infinite-scroll="load1" infinite-scroll-disabled="disabled1" v-if="followMy.length>0">
                    <div class="follow-left-content-box" v-for="(item,index) in followMy" :key="index" @click="goUserDetails(item.user.id)">
                        <div class="follow-left-content-box-left">
                            <img :src="item.user.avatar" alt="">
                            <div class="follow-left-content-box-left-msg">
                                <div>{{item.user.nickname}}</div>
                                <div>ID：{{item.user.id}}</div>
                            </div>
                        </div>
                        <!-- <div class="follow-left-content-box-right">移出关注</div> -->
                    </div>
                </div>
                <div class="follow-left-noContent" v-if="noData1">暂无数据</div>
                <p class="p" v-if="workLoading1">加载中...</p>
                <p class="p" v-if="noMore1 && followMy.length>0 && !workLoading1">没有更多了~</p>
            </div>
        </div>
    </div>
</template>
<script>
import request from "@/utils/request";
import loading from '@/components/loading/loading.vue'
import Cookies from 'js-cookie'
export default {
    components: { loading },
    data(){
        return{
            loading:true,
            myFollow:[],
            followMy:[],
            form1:{
                page:1,
                limit:10, 
                type:1
            },
            form2:{
                page:1,
                limit:10, 
                type:2
            },
            workLoading1:true,
            workLoading2:true,
            noData1:false,
            noData2:false,
        }
    },
    created(){
        if(Cookies.get('Admin-Token')){
            this.getList1()
            this.getList2()
        }
    },
    computed:{
        noMore1 () {
            return this.followMy.length < this.form1.limit
        },
        disabled1 () {
            return this.workLoading1 || this.noMore1
        },
        noMore2 () {
            return this.myFollow.length < this.form2.limit
        },
        disabled2 () {
            return this.workLoading2 || this.noMore2
        }
    },
    methods: {
        load1 () {
            if(!this.noMore1){
                this.form1.limit+=10
                this.getList1()
            }
        },
        load2 () {
            if(!this.noMore2){
                this.form2.limit+=10
                this.getList2()
            }
        },
        goUserDetails(id){
            this.$router.push({
                path:"/forum/userDetails",
                query:{
                    user_id:id
                }
            })
        },
        // 取消关注
        canelFollow(id){
            this.$confirm('此操作将取消关注, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //点击确定的操作(调用接口)
                request({
                    url: "/api/userend/post/followUser",
                    method: "post",
                    params: {user_id:id}
                }).then(response => {
                    this.$message.success("取消关注成功")
                    this.getList2()
                });
            }).catch(() => {
                //几点取消的提示
            });
        },
         // 我的关注
        getList2() {
            this.workLoading2 = true
            request({
                url: "/api/userend/user/follow",
                // url: "/api/userend/post/userAllComment",
                method: "get",
                params: this.form2
            }).then(response => {
                this.myFollow=response.data
                if(response.data.length==0){
                    this.noData2=true
                }
                this.workLoading2 = false
            });
        },
         // 我的关注
        getList1() {
            this.workLoading1 = true
            request({
                url: "/api/userend/user/follow",
                // url: "/api/userend/post/userAllComment",
                method: "get",
                params: this.form1
            }).then(response => {
                this.followMy=response.data
                if(response.data.length==0){
                    this.noData1=true
                }
                this.workLoading1 = false
                this.loading=false
            });
        },
    },
}
</script>
<style lang="scss">
    .height2{
        height: 100vh;
    }
    .follow{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .follow-box{
            width: 49%;
            background: #FFFFFF;
            border-radius: 8px;
            .follow-left{
                height: calc(100vh - 160px);
                border-radius: 8px;
                padding: 20px 30px;
                background: #ffffff;
                .follow-left-title{
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #1E2134;
                    margin-bottom: 20px;
                }
                .follow-left-noContent{
                    font-size: 28upx;
                    font-family: SFProDisplay-Bold, SFProDisplay;
                    font-weight: bold;
                    color: #506176;
                    text-align: center;
                }
                .p{
                    text-align: center;
                }
                .follow-left-content{
                    // height: 400px;
                    // overflow: auto;//增加滚动条
                    .follow-left-content-box{
                        cursor: pointer;
                        padding: 20px 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 1px solid #F9FAFD;
                        .follow-left-content-box-left{
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            img{
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            }
                            .follow-left-content-box-left-msg{
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                                margin-left: 15px;
                                div{
                                    &:nth-child(1){
                                        font-size: 20px;
                                        font-family: PingFangSC-Regular, PingFang SC;
                                        font-weight: 400;
                                        color: #1E2134;
                                    }
                                    &:nth-child(2){
                                        font-size: 16px;
                                        font-family: PingFangSC-Regular, PingFang SC;
                                        font-weight: 400;
                                        color: #506176;
                                    }
                                }
                            }
                        }
                        .follow-left-content-box-right{
                            cursor: pointer;
                            text-align: center;
                            width: 86px;
                            height: 36px;
                            background: #F5FAFE;
                            border-radius: 18px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #3D7EFF;
                            line-height: 36px;
                        }
                    }
                }
            }
        }
    }
</style>